import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getText } from '@storebrand-digital/fms-translations';
import { InboxBase, Container } from './styled';
import Compose from './Compose';
import Items from './Items';
import Heading from '../../components/Heading';
import { clearMessageThreads } from './redux/threadSlice';
import { clearMessages } from '../Chat/redux/messageThreadSlice';
function Inbox() {
    var dispatch = useDispatch();
    useEffect(function () {
        dispatch(clearMessages());
        dispatch(clearMessageThreads());
    }, []);
    function renderHeading() {
        return (React.createElement(Heading, { title: getText('inbox.heading') },
            React.createElement("a", { href: getText('breadcrumb.overview.href') }, getText('breadcrumb.overview.title')),
            React.createElement(RouterLink, { to: "".concat(getText('breadcrumb.messages.href')) }, getText('breadcrumb.messages.title'))));
    }
    return (React.createElement(InboxBase, null,
        renderHeading(),
        React.createElement(Container, null,
            React.createElement(Compose, null),
            React.createElement(Items, null))));
}
export default Inbox;
